var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[(_vm.is_logged)?_c('div',[_c('admin-layout')],1):_c('div',[_c('login-screen')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }